import { Input, Switch, Typography } from "antd";
import type { PieSliceState } from "./pieState";
import { ColorSwatchPicker } from "../shared/ColorSwatchPicker";

const { Text } = Typography;

const PRESET_COLORS = [
  { color: "#d9534f", title: "Red" },
  { color: "#EF7617", title: "Orange" },
  { color: "#FFC83D", title: "Yellow" },
  { color: "#31B452", title: "Green" },
  { color: "#0000FF", title: "Blue" },
  { color: "#000000", title: "Black" },
  { color: "#cccccc", title: "Grey" },
  { color: "#A9A9A9", title: "Dark Grey" },
];

interface PieOptionsPanelProps {
  slice: PieSliceState;
  onPatch: (patch: Partial<PieSliceState>) => void;
}

export function PieOptionsPanel({ slice, onPatch }: PieOptionsPanelProps) {
  return (
    <div className="awm-step-body">
      <div
        style={{
          padding: "8px 10px",
          border: `1px solid ${slice.labelOverrideEnabled ? "#1677ff" : "#e0e5eb"}`,
          borderRadius: 8,
          background: slice.labelOverrideEnabled ? "#f0f5ff" : "#fafbfc",
          display: "flex", flexDirection: "column", gap: 6,
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div>
            <Text strong style={{ fontSize: 12 }}>Override Slice Name</Text>
            <br />
            <Text type="secondary" style={{ fontSize: 11 }}>
              Override the legend/tooltip label for this slice. Replaces the
              auto-generated text (aggregate prefix, athlete subjects, etc.).
            </Text>
          </div>
          <Switch
            size="small"
            checked={slice.labelOverrideEnabled}
            onChange={(v) =>
              onPatch({
                labelOverrideEnabled: v,
                ...(!v && { labelOverride: "" }),
              })
            }
          />
        </div>
        {slice.labelOverrideEnabled && (
          <Input
            size="small"
            placeholder="e.g. Match-Day Player Load"
            value={slice.labelOverride}
            onChange={(e) => onPatch({ labelOverride: e.target.value })}
            maxLength={80}
          />
        )}
      </div>

      <div
        style={{
          padding: "8px 10px",
          border: `1px solid ${slice.enableColorOverride ? "#1677ff" : "#e0e5eb"}`,
          borderRadius: 8,
          background: slice.enableColorOverride ? "#f0f5ff" : "#fafbfc",
          display: "flex", flexDirection: "column", gap: 6,
          marginTop: 8,
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div>
            <Text strong style={{ fontSize: 12 }}>Override Color</Text>
            <br />
            <Text type="secondary" style={{ fontSize: 11 }}>
              Use a custom color instead of the default palette.
            </Text>
          </div>
          <Switch
            size="small"
            checked={slice.enableColorOverride}
            onChange={(checked) => {
              onPatch({
                enableColorOverride: checked,
                ...(checked && !slice.colorOverride && { colorOverride: "#1677ff" }),
                ...(!checked && { colorOverride: "" }),
              });
            }}
          />
        </div>
        {slice.enableColorOverride && (
          <ColorSwatchPicker
            color={slice.colorOverride || ""}
            presetColors={PRESET_COLORS}
            onChange={(hex) => onPatch({ colorOverride: hex })}
          />
        )}
      </div>
    </div>
  );
}
